import type { AiCustomPart, AiMessagePart } from 'juneau';
import type { InvoiceAggregateGroupBy, InvoiceAggregateMetric } from '@insio/shared-types';

export interface AggregateRow {
  label: string;
  /** Decimal serialized as string — parse with new Decimal(x) when math is needed. */
  value: string;
  count: number;
  currency: string;
}

/** One grand value per currency — amounts in different currencies are never combined. */
export interface AggregateTotal {
  currency: string;
  /** Decimal serialized as string — parse with new Decimal(x) when math is needed. */
  value: string;
  invoiceCount: number;
}

export interface AggregateSummaryPartType extends AiCustomPart {
  type: 'aggregate-summary';
  metric: InvoiceAggregateMetric;
  dateFrom: string;
  dateTo: string;
  groupBy: InvoiceAggregateGroupBy;
  /** Label set translating the row labels, when they are keys rather than display text. */
  labelSet?: string;
  totals: AggregateTotal[];
  invoiceCount: number;
  rows: AggregateRow[];
  truncated: boolean;
}

export function isAggregateSummaryPart(part: AiMessagePart): part is AggregateSummaryPartType {
  return (
    part.type === 'aggregate-summary' &&
    Array.isArray((part as AggregateSummaryPartType).totals) &&
    Array.isArray((part as AggregateSummaryPartType).rows)
  );
}
